var getImages = function (_a) {
    var config = _a.config;
    var assets = config.hosts.assets;
    return {
        success: "".concat(assets, "assets/account-services/cli_success.svg"),
        error: "".concat(assets, "assets/account-services/technical_error_cat.svg"),
        ladyWarning: "".concat(assets, "assets/account-services/lady-warning.svg"),
        ladySuccess: "".concat(assets, "assets/account-services/cli_success.svg"),
        addAuthorizedUser: "".concat(assets, "assets/account-services/manage_cardholders.svg")
    };
};
export default getImages;
